import { RouteConfig } from 'vue-router';

import Checkout from '@/views/checkout';

function lazyLoadView(view: string) {
    return () => import(/* webpackChunkName: "views/[request]" */ `@/views/${view}`);
}

export const routes: RouteConfig[] = [
    {
        path: '/',
        name: 'checkout',
        component: Checkout
    },
    {
        path: '/locales/:lang',
        name: 'locales'
    },
    {
        path: '/fail',
        name: 'fail',
        props: true,
        component: lazyLoadView('fail')
    },
    {
        path: '/success',
        name: 'success',
        props: true,
        component: lazyLoadView('success')
    }
];
